<template>
  <label
    class="ps-label ps-block ps-text-sm ps-font-medium ps-leading-5 ps-text-gray-700"
    ><slot
  /></label>
</template>

<script>
export default {
  name: 'BaseLabel',
  props: {
    msg: String
  }
}
</script>
